import React, { Component } from 'react';
import { toInteger, clamp } from 'lodash';
import { BigInputNumber, QuoteButton } from 'components/Styled';

class ParcelNumberInput extends Component {
  state = {
    min: 0,
    max: 199
  };

  formatNumber = n => {
    const { min, max } = this.state;
    return toInteger(clamp(n, min, max));
  };

  handleMinusClick = () => {
    let value = this.props.value;
    value--;
    value = this.formatNumber(value);
    this.props.onChange(value);
  };

  handlePlusClick = () => {
    let value = this.props.value;
    value++;
    value = this.formatNumber(value);
    this.props.onChange(value);
  };

  handleChange = value => {
    value = this.formatNumber(value);
    this.props.onChange(value);
  };

  render() {
    return (
      <div>
        <QuoteButton
          size="small"
          shape="circle"
          onClick={this.handleMinusClick}
          disabled={this.props.disabled}
          type="primary"
          className="theme-button border-buttonSecond-color buttonSecond-background">
          －
        </QuoteButton>
        <BigInputNumber
          min={this.state.min}
          max={this.state.max}
          value={this.props.value || null}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          inputMode="decimal"
          placeholder="0"
        />
        <QuoteButton
          size="small"
          shape="circle"
          onClick={this.handlePlusClick}
          disabled={this.props.disabled}
          type="primary"
          className="theme-button border-buttonSecond-color buttonSecond-background">
          ＋
        </QuoteButton>
      </div>
    );
  }
}

export default ParcelNumberInput;
